
import { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  FormHelperText,
  Grid,
  Typography,
  styled,
} from "@mui/material";
import Footer from "components/common/dialog/Footer";
import Header from "components/common/dialog/Header";
import { useFormik } from "formik";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ForgotPassword } from "redux/slice/session/auth.slice";
import { assetsObj } from "services/images";
import { emailRegex } from "services/utiles";
import * as Yup from "yup";
import { pathApp } from "services/utiles";

// import toast from "styles/toastUtils";
// import { register } from "redux/slice/session/auth.slice";

const WhiteBorderTextField = styled("input")({
  width: "100%",
  padding: "12px 14px",
  backgroundColor: "transparent",
  border: "1px solid white",
  borderRadius: "6px",
  color: "white",
  "&:focus": {
    borderColor: "#ffffff",
  },
  "&::placeholder": {
    color: "white",
  },
  "&:focus-visible ": {
    outline: '1px solid white',
  },
});

const TrialForget = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
      user_type: "",
    },
    enableReinitialize: true,

    validationSchema: Yup.object({
      email: Yup.string()
        .email("Email is invalid")
        .matches(emailRegex, "Invalid email format")
        .required("Email is required"),
    }),

    onSubmit: (value) => {
      value["user_type"] = 2;
      value["type"] = 1;
      console.log("value: ", value);
      setLoading(true);
      dispatch(ForgotPassword(value))
        .unwrap()
        .then((res) => {
          console.log("res", res);
          setLoading(false);
          if (res?.success) {
            navigate(`${pathApp}trial/forgot-verification`);
            localStorage.setItem("email", value.email);
            localStorage.setItem("success", res?.success);
            toast.success("Your 4-digit code was sent to your email");
          }
        });
    },
  });

  return (
    <>
      <Box
        sx={{
          height: "100%",
          color: "white",
          overflow: "auto",
          backgroundImage: `url(${assetsObj.gradientImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Header />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            marginTop:22,
            // height: "calc(100vh - 133px)",
            maxWidth: "auto",
          }}
        >
          <Box maxWidth="md">
            <form onSubmit={formik.handleSubmit}>
              <Grid
                container
                item
                xs={11}
                md={10}
                justifyContent="center"
                margin="auto"
                alignItems="center"
                sx={{
                  "@media (max-width: 599px)": {
                    marginBottom: 14,
                  },
                }}
              >
                <Grid item xs={12} sx={{ marginBottom: 2 }}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 400,
                      textAlign: "center",
                      color: "#fff",
                    }}
                    gutterBottom
                  >
                    We’ll get you back on <br /> Affirmate in no time
                  </Typography>
                </Grid>

                <Grid item xs={12} sx={{ marginBottom: 2 }}>
                  <WhiteBorderTextField
                    placeholder="Your Email"
                    type="input"
                    name="email"
                    onChange={formik.handleChange}
                    value={formik.values.email}
                    onBlur={formik.handleBlur}
                  />
                  {formik.errors.email && (
                    <FormHelperText error>{formik.errors.email}</FormHelperText>
                  )}
                </Grid>

                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: "60px",
                      width: "50%",
                      background: "transparent",
                      border: "1px solid white",

                      textTransform: 'none',
                      "&:hover": {
                        background: "white",
                        color: "black",
                        transition: "0.2s ease-in-out",
                      },
                      mx: "auto",
                    }}
                    type="submit"
                  >
                    {loading ? (
                      <CircularProgress size={22} color="secondary" />
                    ) : (
                      "Send me the code"
                    )}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Box>
        <Footer />
      </Box>
    </>
  );
};

export default TrialForget;
